var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVectorUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.1992 43.5227C42.6957 39.1727 37.9945 36.25 32.625 36.25H25.375C20.0055 36.25 15.3043 39.1727 12.8008 43.5227C16.7883 47.9633 22.5656 50.75 29 50.75C35.4344 50.75 41.2117 47.952 45.1992 43.5227ZM0 29C0 21.3087 3.05535 13.9325 8.4939 8.4939C13.9325 3.05535 21.3087 0 29 0C36.6913 0 44.0675 3.05535 49.5061 8.4939C54.9447 13.9325 58 21.3087 58 29C58 36.6913 54.9447 44.0675 49.5061 49.5061C44.0675 54.9447 36.6913 58 29 58C21.3087 58 13.9325 54.9447 8.4939 49.5061C3.05535 44.0675 0 36.6913 0 29ZM29 30.8125C31.1632 30.8125 33.2377 29.9532 34.7673 28.4236C36.2969 26.894 37.1562 24.8194 37.1562 22.6562C37.1562 20.4931 36.2969 18.4185 34.7673 16.8889C33.2377 15.3593 31.1632 14.5 29 14.5C26.8368 14.5 24.7623 15.3593 23.2327 16.8889C21.7031 18.4185 20.8438 20.4931 20.8438 22.6562C20.8438 24.8194 21.7031 26.894 23.2327 28.4236C24.7623 29.9532 26.8368 30.8125 29 30.8125Z",
    fill: "#E9ECEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorUpload);
export default __webpack_public_path__ + "static/media/VectorUpload.24a69dc2677ef8e140ae8c9d6b77530b.svg";
export { ForwardRef as ReactComponent };